import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  useApiPortalV1AssessmentsPlansOrganizationListQuery,
  useApiPortalV1AssessmentsPlansTasksListQuery,
} from 'areas/assessment-schedule/api';
import { PageContent, PageSection } from 'common/styles/page';
import { useSelector } from 'react-redux';
import LoadingSpinner from 'common/components/LoadingSpinner';
import { getMostRecentAssessmentPeriodId } from 'common/selectors/auth';
import FoundationActionPlan from './FoundationActionPlan';

const FoundationProject = () => {
  const [taskData, setTaskData] = useState<any[]>([]);
  const [actionPlanData, setActionPlanData] = useState<any[]>([]);
  const [isLoaded, setIsLoaded] = useState(false);

  const { id } = useParams();
  const action_plan_id = Number(id) || 0;

  const assessmentPeriodId = useSelector(getMostRecentAssessmentPeriodId);

  const { data: task_data } = useApiPortalV1AssessmentsPlansTasksListQuery({
    assessmentPeriodActionPlanId: action_plan_id,
  });
  const { data: action_plan_data } = useApiPortalV1AssessmentsPlansOrganizationListQuery({
    assessmentPeriodId: assessmentPeriodId,
    assessmentPeriodActionPlanId: action_plan_id,
  });

  useEffect(() => {
    if (task_data && action_plan_data) {
      setIsLoaded(true);
    }
    if (task_data) {
      setTaskData(task_data);
    }
    if (action_plan_data) {
      setActionPlanData(action_plan_data);
    }
  }, [task_data, action_plan_data]);

  if (!isLoaded) {
    return <LoadingSpinner />;
  }

  return (
    <PageContent>
      <PageSection padbottom>
        <PageSection>
          <FoundationActionPlan
            title={
              actionPlanData[0]?.recommendation_name
                ? actionPlanData[0]?.recommendation_name
                : 'Foundation Project'
            }
            description={
              actionPlanData[0]?.recommendation_json?.description
                ? actionPlanData[0]?.recommendation_json?.description
                : ''
            }
            taskData={taskData}
            actionPlanId={action_plan_id}
          />
        </PageSection>
      </PageSection>
    </PageContent>
  );
};
export default FoundationProject;
